import httpClient from '@/http-client'

export const getBranch = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/branches', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getLocation = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/locations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProduct = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCashier = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/cashier', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTransferNumber = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/transfer-number', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const serialStatus = () => {
  return httpClient
    .get('/api/v1/reports/serial-status')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productCategory = () => {
  return httpClient
    .get('/api/v1/reports/product-categories')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const productGroup = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-groups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productProfileLocation = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productProfileLocationList = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-profiles/location-lists', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employee = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCustomer = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/customers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getBranch,
  getLocation,
  getProduct,
  getCashier,
  getTransferNumber,
  serialStatus,
  productCategory,
  productGroup,
  productProfileLocation,
  productProfileLocationList,
  employee,
  getCustomer
}
